/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StudentContext
 */
export interface StudentContext {
    /**
     * 
     * @type {string}
     * @memberof StudentContext
     */
    classId: string;
    /**
     * The page number of the material the student is viewing. 1 indexed.
     * @type {string}
     * @memberof StudentContext
     */
    pageNumber: string;
    /**
     * 
     * @type {string}
     * @memberof StudentContext
     */
    pdfId: string;
    /**
     * 
     * @type {string}
     * @memberof StudentContext
     */
    materialType: string;
}

/**
 * Check if a given object implements the StudentContext interface.
 */
export function instanceOfStudentContext(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "pageNumber" in value;
    isInstance = isInstance && "pdfId" in value;
    isInstance = isInstance && "materialType" in value;

    return isInstance;
}

export function StudentContextFromJSON(json: any): StudentContext {
    return StudentContextFromJSONTyped(json, false);
}

export function StudentContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentContext {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'pageNumber': json['pageNumber'],
        'pdfId': json['pdfId'],
        'materialType': json['materialType'],
    };
}

export function StudentContextToJSON(value?: StudentContext | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'pageNumber': value.pageNumber,
        'pdfId': value.pdfId,
        'materialType': value.materialType,
    };
}

